import { ApiService } from "../model/Api.model";
import { AxiosInstance } from "axios";
import { IBlockedBalance } from '../interface/BlockedBalance/IBlockedBalance';
import { generateQueryString } from 'src/util/helper';

enum BlockedBalanceServiceEnum {
  base = "/"
}

export class BlockedBalanceService extends ApiService {
  constructor(restClient: AxiosInstance) {
    super(restClient, "/blocked-balance");
  }

  public getBlockedBalanceByTrade = async (tradeId: number): Promise<IBlockedBalance> => await this.GET(`${BlockedBalanceServiceEnum.base}?${generateQueryString({ tradeId })}`);
  public provisionTrade = async (blockedBalance: IBlockedBalance) => await this.POST(BlockedBalanceServiceEnum.base, blockedBalance);
}
